import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()

export class LoginService {

  constructor(
  	  private http: HttpClient,
  ) { }

  login(data) {
    return this.http.post<any>(environment.base_url + 'users/login/', data);
  }
}
